export const errorColor = '#EB5757'
export const defaultColor = '#A78966'
export const defaultOOFColor = '#A7896640'
export const manufacturerColor = '#136BFB'
export const manufacturerSecondaryColor = '#4C77BD'
export const manufacturerOOFColor = '#136BFB40'
export const manufacturerSecondaryColorOOFColor = '#4C77BD40'
export const manufacturerHoverColor = '#2213FB'

export const manufacturerProductTypeFillNotSelected = '#136BFB'
export const manufacturerProductTypeOutlineNotSelected = '#04599F'
export const manufacturerProductTypeFillSelected = '#4C77BD'
export const manufacturerProductTypeOutlineSelected = '#30628C'

export const draggingColor = '#D9F3F9'
export const levelOfSpecificationColor = '#C1AC95'
